import { gql } from '@apollo/client';

export const GET_GAME_PLAYS = gql`
  query GetGamePlays($competitionId: Int!, $gameId: [Int!]) {
    selectedCompetitionId @client @export(as: "competitionId")
    selectedGameId @client @export(as: "gameId")

    plays(
      first: 1000
      includeT1Games: true
      filters: {
        competitionId: $competitionId
        gameIds: $gameId
        includeNegated: true
      }
    ) {
      edges {
        node {
          id
          name
          down
          quarter
          quarterClockRemaining
          driveIndex
          gameIndex
          yardsToGo
          yardLine
          type
          yardsNet
          scrimmageEpa
          explosive
          success
          firstDownWon
          touchdownWon
          pointsWon
          qbHit
          qbSacked
          passYardsAir
          yardsRun
          offensePenaltyAccepted
          defensePenaltyAccepted
          penalties {
            type
            name
          }
          penaltyOffset
          penaltyYards
          penaltyFirstDown
          penaltyDownLoss
          downNegated
          turnoverType
          offensivePersonnel
          defensivePersonnel
          formationGroup
          defensiveCoverage
          mofo
          drawnPenalty
          backfieldNumRbs
          homeScore
          awayScore
          drive {
            id
            name
            offensePoints
            defensePoints
            gameIndex
            playCount
            startQuarter
            quarterClockRemaining
            team {
              id
              name
              shortName
            }
            startingYards
            yardsNet
          }
          offenseTeam {
            id
            name
            shortName
          }
          defenseTeam {
            id
            name
            shortName
          }
          game {
            id
            date
            roundShortName
            homeTeam {
              id
              name
              shortName
              colorPrimary
              colorSecondary
              colorTertiary
            }
            awayTeam {
              id
              name
              shortName
              colorPrimary
              colorSecondary
              colorTertiary
            }
            awayScore
            homeScore
          }
        }
      }
    }
  }
`;
